import React, { useContext } from "react";
import { Button } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import classnames from "classnames";
import style from "./Collateral.module.scss";
import { Mode } from "../../../utils";

const Footer = ({ toggle, buttons, actions, dispatch }) => {
  const { precheck, confirm } = buttons;

  return (
    <div className={style.ButtonContainer}>
      <Button color="light" onClick={() => toggle()}>
        Close
      </Button>{" "}
      {precheck.visible && (
        <LaddaButton
          className={classnames("btn btn-ladda btn-primary")}
          loading={precheck.loading}
          onClick={() => actions.precheck()}
          data-style={EXPAND_RIGHT}
        >
          {"Pre check"}
        </LaddaButton>
      )}
      {confirm.visible && (
        <LaddaButton
          className={classnames("btn btn-ladda btn-primary")}
          loading={confirm.loading}
          onClick={() => actions.confirm()}
          data-style={EXPAND_RIGHT}
        >
          {"Confirm"}
        </LaddaButton>
      )}
    </div>
  );
};

export default Footer;
